// «Chi sta facendo cosa»: i pops al lavoro nelle sessioni aperte, ognuno con il suo avatar,
// l'ultima cosa che ha fatto e da quanto.
import { Link } from 'react-router-dom';
import { Pop } from '../../../components/Pop';
import { RelativeTime } from '../../../components/RelativeTime';
import { doing } from '../../../lib/crew';
import type { AgentProfile } from '../../../lib/api';
import type { AgentAtWork } from '../../../store/selectors';
import type { MissionTask, Session } from '../../../types';
import { faceOf } from '../faces';
import { Widget } from '../Widget';

const TINTS = ['blue', 'mint', 'lilac', 'sun', 'pink', 'coral'];

export function People({
  agents,
  sessions,
  tasks,
  profiles,
}: {
  agents: AgentAtWork[];
  sessions: Session[];
  tasks: Record<string, MissionTask[]>;
  profiles: AgentProfile[] | null;
}) {
  const titleOf = (id: string) => sessions.find((s) => s.id === id);
  return (
    <Widget
      title="Chi sta facendo cosa"
      icon="users-round"
      count={agents.length}
      detailsTo="/runtime"
      detailsLabel="Runtime"
      tint="blue"
    >
      {agents.length === 0 ? (
        <div className="t-caption faint">Nessun pop al lavoro in questo momento.</div>
      ) : (
        <div style={{ display: 'grid', gap: 12 }}>
          {agents.slice(0, 6).map((a, i) => {
            const face = faceOf(a.instanceId, tasks[a.sessionId], profiles);
            const s = titleOf(a.sessionId);
            return (
              <Link
                key={`${a.sessionId}|${a.instanceId}`}
                to={`/s/${a.sessionId}`}
                className="dash-person"
                data-tint={TINTS[i % TINTS.length]}
              >
                <span className="dash-face">
                  {face && <Pop avatar={face} size={56} label={a.instanceId} />}
                </span>
                <span className="dash-bubble">
                  <span style={{ display: 'flex', gap: 8, alignItems: 'baseline' }}>
                    <span className="dash-bubble-name">{a.instanceId}</span>
                    <span className="t-caption faint trunc" style={{ flex: 1 }}>
                      {s?.projectName ? `${s.projectName} — ` : ''}
                      {s?.title ?? a.sessionId}
                    </span>
                    <span className="t-caption faint" style={{ whiteSpace: 'nowrap' }}>
                      passo {a.steps} · <RelativeTime at={a.last.at} />
                    </span>
                  </span>
                  <span className="dash-bubble-text trunc">{doing(a, tasks[a.sessionId], s)}</span>
                </span>
              </Link>
            );
          })}
        </div>
      )}
    </Widget>
  );
}
